<template>
  <div>
    <div v-if="downloading" class="loading-mask">
      Downloading...
    </div>
    <PageHeader :title="typeName" class="list">
      <template #title-header-content>
        <div class="flex-1 flex ml-2 justify-end items-center">

          <!-- 一括ダウンロード -->
          <div class="mr-2 flex">
            <PrimaryButton
              :text="`☑ 一括ダウンロード（${selectedRows.length}件）`"
              :buttonContents="'要'"
              class="bg-blue-600"
              :disabled="!selectedRows.length"
              @click="download(null)"
            />
          </div>

          <!-- 検索ボタン -->
          <PrimaryButton
            text="検索"
            class="flex button-contents"
            @click="getData(1)"
            :buttonContents="'要'"
          >
          </PrimaryButton>

          <h1 class="text-lg font-bold text-white flex items-center ml-2">
            <Icon iconName="" class="w-7 h-7 mr-2" /> <span class="mt-0 ">{{ records }} 件</span>
          </h1>

          <div class="ml-2 flex">
            <PrimaryButton text="クリア" size="normal px-2" class="normalButtonColor" @click="clear" :buttonContents="'要'" />
          </div>

          <Icon
            iconName="Refresh"
            :clickable="false"
            :class="{'animate-spin': loading}"
            class="text-white hover:text-gray-300 active:text-gray-400 ml-4 cursor-pointer"
            @click.native="getData"
          />
        </div>
      </template>
      <template #page-header-content>
        <div class="flex justify-end">
          <!-- 作業日 -->
          <div class="mr-2">
            <DateSelect
              id="filterDate"
              v-if="true"
              ref="dateSelect"
              :presetName="filter.periodPresetName"
              :period="filter.period"
              :none="true"
              @change="periodChange"
              titleText="作業日:"
            />
          </div>
          <!-- 得意先 -->
          <div class="mr-2">
            <input
              v-tooltip="'記号・スペースは無視します'"
              type="search"
              name="filterClient"
              placeholder="得意先 検索"
              class="w-full py-2 pr-3 border border-gray-300 rounded-md leading-5 focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900"
              v-model="filter.filterClient"
            />
          </div>
          <!-- 物件名 -->
          <div class="mr-2">
            <input
              v-tooltip="'記号・スペースは無視します'"
              type="search"
              name="filterSite"
              placeholder="物件名 検索"
              class="w-full py-2 pr-3 border border-gray-300 rounded-md leading-5 focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900"
              v-model="filter.filterSite"
            />
          </div>
          <!-- 担当者 -->
          <div class="">
            <input
              v-tooltip="'スペースは無視します'"
              type="search"
              name="filterStaff"
              placeholder="責任者 検索"
              class="w-full py-2 pr-3 border border-gray-300 rounded-md leading-5 focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900"
              v-model="filter.filterStaff"
            />
          </div>
        </div>
      </template>
    </PageHeader>

    <main class="absolute top-28 w-screen bottom-2 list">
      <div class="mx-auto px-2 sm:px-4 lg:px-8 h-full">
        <div class="bg-white rounded-md h-full">
          <!-- 一覧 -->

          <div v-if="loading" class="w-full h-full flex justify-center items-center">
            <p class="text-gray-400 font-bold animate-pulse">Searching...</p>
          </div>

          <div v-if="!loading" class="h-full">
            <div v-if="list&&list.length" class="rounded border border-gray-200 overflow-auto main-height">
              <table class="w-full">
                <thead class="sticky top-0">
                  <tr v-if="list && list.length" class="border border-gray-200 text-xs font-medium text-gray-500 tracking-wider bg-colu">
                    <th scope="col" class="px-3 py-1 text-left">
                      <div>物件名</div>
                      <div>得意先</div>
                    </th>

                    <th scope="col" class="px-3 py-1 text-left">作業日</th>
                    <th scope="col" class="px-3 py-1 text-left">
                      <div class="text-yellow-700">予定時刻</div>
                      <div>実施時刻</div>
                    </th>

                    <th scope="col" class="px-3 py-1 text-left">作業項目</th>
                    <th scope="col" class="px-3 py-1 text-left">
                      責任者
                      <div>人数</div>
                      <div>天候</div>
                    </th>
                    <th scope="col" class="px-3 py-1 text-right">平均/日</th>
                    <th scope="col" class="px-3 py-1 text-right">ダウンロード</th>
                    <!-- 一括選択 -->
                    <th scope="col" class="px-3 py-1 text-center col-check">
                      <input
                        v-tooltip="'このページをすべて選択／解除'"
                        type="checkbox"
                        class="cursor-pointer"
                        :checked="allSelected"
                        :disabled="!selectableList.length"
                        @change="toggleAll"
                      />
                      <div v-if="selectedRows.length" class="text-blue-700 whitespace-nowrap">{{ selectedRows.length }}件</div>
                    </th>
                  </tr>
                </thead>

                <tr v-for="(row, i) in list" :key="'l'+i" class="border border-gray-200 bg-white tracking-wider hover-color">
                  <!-- 物件名・得意先 -->
                  <td class="px-3 py-3 whitespace-nowrap text-sm text-gray-700 " v-tooltip="`得意先コード：${row.clientCode}、物件コード：${row.siteCode}`" @click="open(row)">
                    <div class="font-bold">
                      {{ row.siteName }}<span v-if="row.ridgeCode" class="text-red-700 font-bold">（{{ row.ridgeName }}）</span>
                    </div>

                    <div class="text-xs mt-1">{{ row.clientName1 }}</div>
                    <div class="text-xs mt-1">{{ row.clientName2 }}</div>
                  </td>

                  <!-- 作業日 -->
                  <td class="px-3 py-3 whitespace-nowrap text-sm text-gray-700 min-100" @click="open(row)">
                    {{ row.completionDate }}
                    <span v-if="row.incomplete"  class="text-xs p-1 bg-green-50 text-green-700 rounded">複数日未完了</span>
                  </td>

                  <!-- 開始～終了時間、天気 -->
                  <td class="px-3 py-3 whitespace-nowrap text-sm text-gray-700 min-100" @click="open(row)">
                    <div v-if="row.scheduleTime" class="mb-1 text-yellow-700 font-bold">
                      {{ row.scheduleTime }}
                    </div>
                    <div>{{ row.startEndTime }}</div>
                  </td>

                  <!-- 項目 -->
                  <td class="px-3 py-3 whitespace-pre-line text-xs text-gray-700 " @click="open(row)">
                    {{ row.items ? row.items.join('\n') : '' }}
                    <div v-if="!row.main" class="text-blue-700">※1日目にまとめて記載</div>
                  </td>

                  <!-- 責任者 -->
                  <td class="px-3 py-3 whitespace-nowrap text-xs text-gray-700 " @click="open(row)">
                    <div class="font-bold text-gray-600">{{ row.staff }}</div>
                    <div class="mt-1">
                      <span v-if=" row.peopleTitle">{{ row.peopleTitle }}：</span>
                      <span class="font-bold text-sm">{{ row.people }}</span>
                    </div>
                    <div class="mt-1">（{{ row.weather }}）</div>
                  </td>

                  <!-- 平均 -->
                  <td class="text-right px-3 py-3 whitespace-prerap text-xs text-gray-700 w-36" @click="open(row)">
                    {{ row.times }}
                  </td>

                  <!-- ダウンロード -->
                  <td class="text-center w-24">
                    <span v-if="!row.main"  class="text-xs p-1 bg-blue-50 text-blue-700 font-bold rounded">{{ row.num }}日目</span>
                    <PrimaryButton v-tooltip="'ダウンロード'" @click="download(row)" :buttonContents="'要'" v-else-if="!row.incomplete && row.main">
                      <Icon slot="before" iconName="Download" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
                    </PrimaryButton>
                  </td>

                  <!-- 一括ダウンロード選択 -->
                  <td class="text-center col-check">
                    <input
                      v-if="!row.incomplete && row.main"
                      type="checkbox"
                      class="cursor-pointer"
                      :checked="isSelected(row)"
                      @change="toggleRow(row)"
                    />
                  </td>
                </tr>
              </table>
            </div>

            <div v-if="list&&list.length" class="w-fit mx-auto mt-2">
              <pagination id="pagenation" v-model="page" :per-page="perPage" :records="records" class="text-center" @paginate="getData" />
            </div>
            <div v-else class="w-full h-full flex justify-center items-center text-gray-400">
              <EmptyMessage
                iconName="Document"
                message="該当する案件はありません。"
              />
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import Icon from '@components/Icon.vue'
import PageHeader from '@components/PageHeader.vue'
import DateSelect from '@components/DateSelect.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import Pagination from 'vue-pagination-2'
import EmptyMessage from '@components/EmptyMessage.vue'
import * as moment from 'moment'
import * as backend from '@libs/backend'
import * as utils from '@libs/utils.js'
import PageModel from '../../main/pages/PageModel.vue'

const settionStrageName = 'FixedCheckListStorageItemName'
const settionStrageName2 = 'FixedCheckListStorageItemName2'

export default {
  extends: PageModel,
  components: {
    Icon,
    PageHeader,
    DateSelect,
    PrimaryButton,
    Pagination,
    EmptyMessage
  },

  data() {
    return {
      loading: false,
      downloading: false,

      typeName: '定期清掃',
      type: 3,
      // クレーム
      claim: false,
      // スポット
      spot: false,

       //検索保持用
      filter: {
        filterClient : '',
        filterSite : '',
        filterStaff: '',
        period: { start: moment().startOf('month').format('YYYY-MM-DD'), end: moment().endOf('month').format('YYYY-MM-DD') },
        periodPresetName: 'custom'
      },
      // 表示するデータ
      list: [],
      // 一括ダウンロード対象に選択された patrolScheduleId（ページを跨いで保持し、ダウンロード実行までクリアしない）
      // 複数日作業は日数分の patrolScheduleId を保持するため重複するが、重複削除はバック側で行う
      selectedRows: [],
      // チェックリスト
      checkList: {clientName: '', siteName: '', date: '', staff: ''},
      // モーダルopen
      openModal: 0,
      // ページ数
      page: 1,
      // １ページの最大件数
      perPage: 100,
      // 全件数
      records: 0,
    }
  },

  async created() {
    // 条件取得
    this.getCondition()

    await this.getData()
  },

  computed: {
    /**
     * 表示中ページで一括ダウンロードの対象にできる行（1日目 かつ 全日完了済み）
     */
    selectableList() {
      return this.list.filter(row => !row.incomplete && row.main)
    },

    /**
     * 表示中ページの対象行がすべて選択済みか
     */
    allSelected() {
      return !!this.selectableList.length && this.selectableList.every(row => this.isSelected(row))
    },
  },

  methods: {
    /**
     * 選択済みか判定
     * @param row 対象行
     */
    isSelected(row) {
      return this.selectedRows.includes(row.patrolScheduleId)
    },

    /**
     * 同一スケジュールの行（複数日作業の2日目以降を含む）
     * 表示中ページの行のみを対象とする。件数表示は「このページでどれを選んだか」の目印であり、
     * 表示件数を超える数が出る方が不具合に見えるため、別ページの作業日は意図的に数えない
     * @param row 対象行
     */
    sameScheduleRows(row) {
      return this.list.filter(r => r.patrolScheduleId === row.patrolScheduleId)
    },

    /**
     * 選択／解除の切り替え
     * 選択時は複数日作業の2日目以降（チェックボックス非表示の行）も選択件数に含める
     * @param row 対象行
     */
    toggleRow(row) {
      if (this.isSelected(row)) {
        this.selectedRows = this.selectedRows.filter(id => id !== row.patrolScheduleId)
      } else {
        this.sameScheduleRows(row).forEach(r => this.selectedRows.push(r.patrolScheduleId))
      }
    },

    /**
     * 表示中ページの対象行をまとめて選択／解除
     * 選択時は既存の選択に追加し、選択済みのスケジュールは追加しない
     */
    toggleAll(e) {
      if (e.target.checked) {
        this.selectableList.forEach(row => {
          if (!this.isSelected(row)) {
            this.sameScheduleRows(row).forEach(r => this.selectedRows.push(r.patrolScheduleId))
          }
        })
      } else {
        const ids = new Set(this.selectableList.map(row => row.patrolScheduleId))
        this.selectedRows = this.selectedRows.filter(id => !ids.has(id))
      }
    },

    /**
     *  条件取得
     */
    getCondition(){
      const searchJson = sessionStorage.getItem(settionStrageName)
      const getItem = JSON.parse(searchJson)

      if (getItem) {
        this.filter = getItem
      }

      const searchJson2 = sessionStorage.getItem(settionStrageName2)
      const getItem2 = JSON.parse(searchJson2)
      if (getItem2) {
        if (getItem2.perPage) {
          this.perPage = getItem2.perPage
        }
        if (getItem2.page) {
          this.page = getItem2.page
        }
      }
    },

    /**
     * データ取得
     */
    async getData(page) {
      this.loading = true
      this.list = []
      this.records = 0
      if (page) {
        this.page = page
      }

      const checkR = await backend.postData('patrolResult/getFixedComplete', { ...this.filter, type: this.type, page: this.page, perPage: this.perPage })
      if (checkR.data && checkR.data.data.length) {
        this.list = checkR.data.data
        this.records = Number(checkR.data.data[0].total)
      }

      // セッションストレージ保存
      this.setSessionStorage()
      this.loading = false

      this.$refs.dateSelect.setRange(this.filter.period, this.filter.periodPresetName, true)
    },

    /**
     * 点検日検索 変更
     */
    periodChange(range, presetName) {
      this.filter.period = range
      this.filter.periodPresetName = presetName
    },

    /**
     * 検索条件をセッションストレージへ保存
     */
    setSessionStorage() {
      const searchStr = JSON.stringify(this.filter)
      sessionStorage.setItem(settionStrageName, searchStr)
      const searchStr2 = JSON.stringify({ page: this.page, perPage: this.perPage })
      sessionStorage.setItem(settionStrageName2, searchStr2)
    },

    /**
     * 点検表open
     * @param row 対象行
     */
    open(row) {
      // 点検表に遷移
      this.$router.push({
        name: 'FixedCheckListTable',
        query: { scheduleId: row.patrolScheduleId, claim: false, sub: -1 },
        params: { scheduledDate: row.scheduledDate, routerName: 'FixedCheckList' }
      })
    },

    /**
     * 検索条件をクリア
     */
    clear() {
      sessionStorage.removeItem(settionStrageName)
      this.$router.go({path: this.$router.currentRoute.path, force: true})
    },

    /**
     * ダウンロードイベント
     * @param row 対象行（1件のみの場合）
     */
    async download(row) {
      this.downloading = true
      let param = {}
      let isBulk = false
      let application = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      let name = ''

      // 1件のみ
      if (row) {
        param = {
          patrolScheduleId: row.patrolScheduleId,
          completionDate: row.completionDate
        }

        name = (row.clientName1 ? row.clientName1.replace('株式会社', '') + '様' : '')

        // 東急住宅のﾌﾗｯﾄ喜多見だけ報告書得意先が違う
        if (row.clientName1.includes('東急住宅') && utils.hankaku(row.siteName) === 'ﾌﾗｯﾄ喜多見') {
          name = '三元建設'
        }

        if (row.siteName) {
          let ridge = ''
          if (row.ridgeCode) {
            ridge = '_' + row.ridgeName
          }
          name += '【' + row.siteName + ridge + '】'
        }
        name += '定期清掃報告書' + moment().format('YYYYMMDD')

        // 野村不動産の新フォーマットのみ、ファイル名名指定
        const tempId = utils.getTempId(row.clientName1, row.siteName)
        if (tempId == 10) {
          name = `●NPT協力会社＿清掃作業写真報告書（${row.siteName}）`
        }

      // 一括
      } else {
        isBulk = true
        application = 'application/zip'
        param.list = [...new Set(this.selectedRows)]
        name = '定期清掃'
      }

      param.isBulk = isBulk

      try {
        const res = await backend.postBlob2('patrolDownload/downloadFixedClean', param)
        const uint8Array = res.data
        const blob = new Blob([uint8Array], { type : application })
        const a = document.createElement("a")
        a.href = (window.URL || window.webkitURL).createObjectURL(blob)

        a.download = name + (isBulk ? '.zip' : '.xlsx')
        a.click();
        a.remove();

        if (isBulk) this.selectedRows = []

        this.downloading = false
      } catch (e) {
        console.log(e)
        alert(e)
        this.downloading = false
      }
    },
  },
}
</script>
<style scoped>

.list {
  min-width: 1250px !important;
  /* bottom: auto !important; */
}

.main-height {
  height: calc(100% - 67px);
}

.bg-colu {
    background: #ebf0fb;
}

.col-no {
    width: 70px;
}

.min-100 {
    min-width: 100px;
}

/* 一括ダウンロード選択 */
.col-check {
    width: 70px;
    font-size: x-small;
}

.col-check input[type=checkbox] {
    width: 16px;
    height: 16px;
}

.hover-color:hover {
  background: rgba(163, 231, 228, 0.67) !important;
  cursor: pointer;
}

.border-b {
  border: solid 1px gray ;
}

#filterDate {
  width: 256px !important;
}

#filterDate >>> div {
  color: rgb(70, 70, 70) !important;
}

#filterDate >>> input[type=text] {
  background: white !important;
}

/* ページネーション */
#pagenation >>> ul {
  display: flex !important;
  color: rgb(6, 125, 194);
  font-weight: bold !important;
  cursor: pointer;
}

#pagenation >>> ul > li {
  padding: 0 10px;
}

#pagenation >>> ul > .active {
  background: rgb(6, 125, 194);
  color: white;
}

#pagenation >>> p {
  color: gray;
  font-size: small;
}
</style>